import api from './api';

export interface Invitation {
  id: string;
  email: string;
  status: 'pending' | 'accepted' | 'expired' | 'revoked';
  roleName?: string;
  invitedBy?: string;
  expiresAt: string;
  createdAt: string;
  acceptedAt?: string;
}

export interface CreateInvitationData {
  email: string;
  roleId?: string;
}

export const invitationService = {
  async getInvitations(): Promise<Invitation[]> {
    const response = await api.get<Invitation[]>('/company/invitations');
    return response.data;
  },

  async createInvitation(data: CreateInvitationData): Promise<Invitation> {
    const response = await api.post<Invitation>('/company/invitations', data);
    return response.data;
  },

  async revokeInvitation(invitationId: string): Promise<void> {
    await api.delete(`/company/invitations/${invitationId}`);
  },

  async resendInvitation(invitationId: string): Promise<void> {
    await api.post(`/company/invitations/${invitationId}/resend`);
  },
};

export default invitationService;
